<template>
  <!-- 我的账号 -->
  <div id="myPrivilege">
    <!-- <close-button></close-button> -->
    
    <div class="title">
      <van-icon size="20" name="arrow-left" @click="$router.back()" />
      <span style="color:#333; margin-left:35%; font-size:16px">我的账号</span>
    </div>
    <div class="privilege">
      <p>账号信息</p>
      <div>
        <van-cell title="账号" :value="userId" />
        <van-cell title="手机" :value="phone | mobileFilter" />
        <van-cell v-if="wxunionid && wxopenid" title="微信" value="已关联" />
        <van-cell  v-if="!wxunionid" title="微信" value="关联微信" is-link @click="onSelect" />
      </div>
      <p>账号等级包</p>
       <div  v-for="(item, i) in userProduct"
        :key="i">
        <van-cell title="产品名称" :value="item.productname">
          <template #right-icon>
            <van-button class="xufei-btn" @click="$router.push('/onlineMall')"> 续费
            </van-button>
          </template>
        </van-cell>
        <van-cell title="开始时间" :value="item.starttime" />
        <van-cell  title="到期时间" :value="item.endtime" />
      </div>
      <div v-if="this.userProduct === null" class="orderList">
        <p style="text-align: center">暂无数据</p>
      </div>
      <div class="open-time-wapper">
        <div class="open-max-item">
          <div>
            <span class="open-font">文件访问上限次数:</span>
            <span v-if="maxopennum == 999999">无限制</span>
            <span v-else class="open-number">{{opennum}}/{{maxopennum}}</span>
          </div>
          <van-button
            v-if="maxopennum != 999999" size="small" type="primary"
            @click="$router.push('/onlineMall')">
            去升级
          </van-button>
        </div>
      </div>
      
      <template v-if="mallver == 'v1'">
        <h4>vip升级包</h4>
        <div v-if="this.userFunction === null" class="orderList">
          <p style="text-align: center">暂无数据</p>
        </div>
        <div v-else>
          <div
            class="orderList"
            v-for="(item, index) in userFunction"
            :key="index"
          >
            <div class="listItem">
              <div class="leftWord">功能名称：</div>
              <div class="rightWord">{{ item.func_name }}</div>
            </div>
            <div class="listItem">
              <div class="leftWord">购买数量：</div>
              <div class="rightWord">{{ item.func_number }}</div>
            </div>
            <div class="listItem">
              <div class="leftWord">开始时间：</div>
              <div class="rightWord">{{ item.starttime }}</div>
            </div>
            <div class="listItem">
              <div class="leftWord">到期时间：</div>
              <div class="rightWord">{{ item.endtime }}</div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <!-- 续费弹框 -->
    <van-popup
      v-model="show"
      closeable
      close-icon="close"
      @close="closePopup"
      position="top"
      :style="{ height: '100%', width: '100%' }"
    >
      <div id="xuFeiPage">
        <div class="titleWord">
          <van-divider :style="{ fontSize: '17px', marginTop: '30px' }">
            续购VIP升级权限
          </van-divider>
        </div>
        <div class="payMethodsxf">
          <div>续费规则：会员有效期到期前15天为续费期，开启续费功能</div>
        </div>
        <div class="line"></div>
        <div class="payMethodsxf">
          <div class="word word_1">账号等级</div>
          <van-tag type="success" size="medium">
            {{ xufeiItem.productname }} ({{
              moment(xufeiItem.starttime).format("YYYY-MM-DD")
            }}
            - {{ moment(xufeiItem.endtime).format("YYYY-MM-DD") }}) </van-tag
          ><span style="color: #07c160">(已购)</span>
          <div class="word word_1">升级时长：{{ vipItemBuyDay }}天</div>
          <div class="word word_1">VIP升级权限</div>
          <div class="vip-box">
            <div
              v-for="item in gridItems"
              :key="item.funccode"
              class="vip-box-item"
            >
              <div class="vip-title">
                {{ item.funcname }} (已购: {{ item.alreadybought_1 }})
              </div>
              <div class="num">
                <van-stepper
                  v-model.number="item.alreadybought_3"
                  integer
                  input-width="60px"
                  :min="item.minctive"
                  :max="
                    item.alreadybought_1 == 0
                      ? item.maxactive
                      : item.maxactive - item.alreadybought_1
                  "
                  @change="inputChange"
                  :disabled="item.alreadybought_1 >= item.maxactive"
                />
              </div>
              <div class="price">
                &yen;
                <span
                  v-if="item.alreadybought_1 < item.maxactive"
                  style="color: red"
                >
                  {{
                    (item.price * vipItemBuyDay * item.alreadybought_3)
                      | toDecimal
                  }}元
                </span>
                <span v-else style="color: red">0.00元</span>
              </div>
            </div>
            <!-- <div style="color: #07C160;" @click="goToSmartcloud">管理文件仓库</div> -->
          </div>
          <div class="word word_1">优惠信息</div>
          <van-cell-group>
            <van-cell
              v-for="item in discountdescdetail"
              :key="item.discountdesc"
              :title="item.discountdesc"
            >
              <template #right-icon>
                <span v-if="item.selected === false">未满足</span>
                <van-radio v-if="item.selected === true"></van-radio>
              </template>
            </van-cell>
          </van-cell-group>
          <div class="line"></div>
          <template v-if="isConpponma">
            <van-field
              v-model="coupon"
              center
              clearable
              label="优惠码"
              placeholder="请输入优惠码"
              @clear="clearCoupon"
              :disabled="checked ? true : false"
            >
            </van-field>
            <van-cell title=" ">
              <template #right-icon>
                <span style="margin-right: 10px">确认使用优惠码</span>
                <van-checkbox
                  :disabled="coupon ? false : true"
                  @change="changeChecked"
                  v-model="checked"
                />
              </template>
            </van-cell>
            <van-cell title=" ">
              <template #right-icon>
                <span style="margin-right: 10px; color: green">{{
                  checked ? alertMessage_1 : ""
                }}</span>
              </template>
            </van-cell>
          </template>
          <div class="line"></div>
          <div @click="drawABill">
            <van-cell title="发票" is-link :value="invoiceWord" />
          </div>
        </div>
        <div class="line"></div>
        <div class="payMethodsxf">
          <div class="word word_1">请选择支付方式</div>
          <van-radio-group v-model="radioPay">
            <van-cell-group>
              <van-cell clickable @click="radioPay = '1'">
                <template #title>
                  <van-image width="30" height="30" :src="wxImg" />
                  <span class="custom-title">微信支付</span>
                </template>
                <template #right-icon>
                  <van-radio name="1" />
                </template>
              </van-cell>
              
            </van-cell-group>
          </van-radio-group>
        </div>
        <van-submit-bar
          :disabled="totalPrice > 0 ? false : true"
          :price="totalPrice"
          button-text="去支付"
          :loading="loadingFlag ? true : false"
          @submit="onSubmit"
        >
          <!-- <del style="color: #ccc;">原价：{{ oldPrice | toDecimal }}</del> -->
        </van-submit-bar>
      </div>
    </van-popup>
    <!-- 合同内容 用户协议 -->
    <van-popup
      v-model="userAgreement"
      @close="closePopup"
      closeable
      close-icon="close"
      position="top"
      :style="{ height: '100%', width: '100%', backgroundColor: '#F5F5F5' }"
    >
      <div id="word_11"></div>
      <user-agreement-pop
        :userAgreementData="userAgreementData"
        :sumMoney="sumMoney"
      >
      </user-agreement-pop>
      <van-tabbar
        :border="false"
        style="
          background-color: #fff;
          diaplay: flex;
          justify-content: center;
          align-items: center;
          height: 50px;
        "
      >
        <van-button
          style="height: 70%; width: 4rem"
          type="info"
          block
          round
          size="small"
          @click="agreePayMoney"
          >同意并确认支付</van-button
        >
        <van-button
          style="height: 70%; width: 100px; margin-left: 20px"
          type="default"
          block
          round
          size="small"
          @click="closePopup"
          >取消支付</van-button
        >
      </van-tabbar>
    </van-popup>
    <!-- VIP升级协议 -->
    <van-popup
      v-model="vipUpgradeAgreement"
      @close="closePopup"
      closeable
      close-icon="close"
      position="top"
      :style="{ height: '100%', width: '100%', backgroundColor: '#F5F5F5' }"
    >
      <div id="word_22"></div>
      <VIPAgreementPop
        :userAgreementData="userAgreementData"
        :sumMoney="sumMoney"
      >
      </VIPAgreementPop>
      <van-tabbar
        :border="false"
        style="
          background-color: #fff;
          diaplay: flex;
          justify-content: center;
          align-items: center;
          height: 50px;
        "
      >
        <van-button
          style="height: 70%; width: 4rem"
          type="info"
          block
          round
          size="small"
          @click="agreePayMoney"
          >同意并确认支付</van-button
        >
        <van-button
          style="height: 70%; width: 100px; margin-left: 20px"
          type="default"
          block
          round
          size="small"
          @click="closePopup"
          >取消支付</van-button
        >
      </van-tabbar>
    </van-popup>
    <!-- 开票弹框页面 -->
    <invoice-page
      ref="invoice"
      :totalPrice="totalPrice"
      @getInvoiceParams="getInvoiceParams"
    ></invoice-page>
  </div>
</template>

<script>
import InvoicePage from "@/components/common/invoice";
import userAgreementPop from "@/components/newcommon/userAgreement";
import VIPAgreementPop from "@/components/newcommon/VIPAgreement";

import CloseButton from "@/components/common/closebutton";
import baseConfig from "../../../public/config.json";
import { getWxOpenIdUrl } from "../../../public/config.json";
import { wxpayFunc } from "@/utils/lib/wxpay.js";
import { ISCONPPONMA } from "@/assets/js/gb.js";
import { commonToast } from "@/utils/lib/toast.js";

// import eventbus from "@/utils/bus.js";

export default {
  data() {
    return {
      checked: false,
      loadingFlag: false,
      show: false,
      userProduct: [], // 产品列表
      userFunction: [], // 功能列表
      radio: "1",
      coupon: "", // 优惠卷
      agentCode: "", // 运营商编码
      invoiceWord: "", // 发票显示文字
      invoiceData: {
        // 发票弹框的内容
        invoicetype: 1,
        invoiceheader: {
          headertype: 1,
          headername: "",
          headercode: "",
          officeaddress: "",
          mobilenumber: "",
          bankname: "",
          bankaccount: "",
        },
      },
      radioPay: "1",
      numValue: 5, // 文件夹个数
      numValueFp: 3, // 分屏个数
      wxImg: require("../../assets/shop/wx.png"),
      zfbImg: require("../../assets/shop/zfb.png"),
      totalPrice: 0, // 购物车中的总价 格式 0000
      totalMoney: 0, // 总价 格式 0.00
      totalPriceYou: 0,
      totalMoneyYou: 0,
      oldPrice: 0, // 原价
      years: [], // 主套餐选择年份优惠价格
      xufeiItem: {}, // 点击续费保存信息
      effectiveorders: [], // 已购商品数据
      gridItems: [], // 获取扩展功能包数据
      result: [],
      vipItemBuyDay: 0, // 续费天数
      discountdescdetail: [], // vip优惠信息
      productcodeMenu: "", // 主套餐的code
      productcodeMenuOrderId: "", // 订单id
      yearDiscountcode: "", // 主套餐优惠code
      dataForm: "", // 跳转地址
      userAgreement: false, // 用户协议
      vipUpgradeAgreement: false, // VIP升级协议
      userAgreementData: {}, // 合同返回得内容
      sumMoney: 0, // 合同中的合计
      iconCouponFlag: false, // 优惠码的错误提示
      alertMessage: "", // 优惠码提示信息
      alertMessage_1: "", // 优惠码返回的优惠信息

      isConpponma: ISCONPPONMA, // 是否显示优惠码
    };
  },
  components: {
    InvoicePage,
    CloseButton,
    userAgreementPop,
    VIPAgreementPop,
  },
  computed: {
    userId() {
      return this.$store.state.user.userId;
    },
    accounttype() {
      return this.$store.state.user.accounttype;
    },
    phone() {
      return this.$store.state.user.mobileNum;
    },
    wxunionid() {
      return sessionStorage.getItem("wxunionid");
    },
    wxopenid() {
      return sessionStorage.getItem("wxopenid");
    },
    mallver() {
      return this.$store.state.user.mallver;
    },
    maxopennum() {
      return this.$store.state.user.maxopennum;
    },
    opennum() {
      return this.$store.state.user.opennum;
    }
  },
  // 过滤电话号码
  filters: {
    mobileFilter(val) {
      let reg = /^(.{3}).*(.{4})$/;
      if (val) {
        return val.replace(reg, "$1****$2");
      }
    },
  },
  created() {
    //console.log('wxunionid', sessionStorage.getItem("wxunionid"))
  },
  mounted() {
    this.getUserProduct();
    this.getUserFunction();
  },
  methods: {
    // 关联微信
    onSelect() {
      // eventbus.$emit("onSelect", "关联微信");
      this.$dialog
        .confirm({
          message: "是否关联微信",
          confirmButtonText: "是",
          cancelButtonText: "否",
          confirmButtonColor: "#4D8FFE"
        })
        .then(async () => {
          let res = await this.$http.reqPostGetWeixinPromise({
            http_redirct: baseConfig.wxUserBindRedirectUrl,
          });
          if (res.rtncode === 1 && res.rltcode === 1) {
            location.href = res.item.url;
          }
        })
        .catch((err) => {
          console.log("关联微信====>", err);
        });
    },
    // 优惠码清除按钮
    clearCoupon() {
      this.checked = false;
    },
    changeChecked(name) {
      if (name == true) {
        this.caleCouponCodeAndAgentCode();
      } else {
        this.totalMoney = this.totalMoneyYou;
        this.totalPrice = this.totalPriceYou;
        this.alertMessage_1 = "";
      }
    },
    // 计算优惠码和运营商编码优惠信息
    caleCouponCodeAndAgentCode() {
      if (this.checked) {
        let params = {
          amount: this.totalMoney,
          couponcode: this.coupon,
          agentcode: this.agentCode,
        };
        console.log("paramsparams", params);
        this.$http
          .reqCaleCouponCodeAndAgentCode(params)
          .then((res) => {
            console.log("计算优惠码和运营商编码优惠信息res===>", res);
            if (res.rtncode === 1) {
              if (res.rltcode === 1) {
                if (res.item.couponrlt) {
                  this.iconCouponFlag = true;
                  this.alertMessage_1 = res.item.discountdesc;
                  this.totalMoney = res.item.amount;
                  this.totalPrice = res.item.amount * 100; // 折后价
                } else {
                  this.iconCouponFlag = false;
                  this.alertMessage = res.item.couponrltdesc;
                }
              }
            }
          })
          .catch((err) => {
            console.log("计算优惠码==>", err);
          });
      }
    },
    // 获取已订购的产品列表
    getUserProduct() {
      this.$http
        .reqGetUserProduct()
        .then((res) => {
          this.userProduct = res.items;
        })
        .catch((err) => {
          console.log("获取订购产品====>", err);
        });
    },
    // 获取已订购的功能列表
    getUserFunction() {
      this.$http
        .reqGetUserFunction()
        .then((res) => {
          this.userFunction = res.items;
        })
        .catch((err) => {
          console.log("获取订购功能 ===>", err);
        });
    },
    // 续费按钮
    xufei(item, type) {
      if (
       sessionStorage.getItem("userId") &&
        !sessionStorage.getItem("wxopenid") &&
        Number(localStorage.getItem("WX_VERSION")) === 1
      ) {
        // 账号登录的
        // 没有微信授权  让微信授权
        console.log("没有微信授权  让微信授权");
        this.$http
          .reqPostGetWeixinPromise({
            http_redirct: getWxOpenIdUrl,
          })
          .then((res) => {
            location.href = res.item.url;
          })
          .catch((err) => {
            console.log("用户微信内账号登录获取权限", err);
          });
        return;
      }
      if (type == "main") {
        this.$router.push("xuFeiPage");
      } else if (type == "vip") {
        this.show = true;
        this.xufeiItem = item;
        console.log("this.xufeiItem", this.xufeiItem);
        if (item.productcode === "000001") {
          this.isConpponma = false;
        }
        this.firstGetInvoiceParams();
        this.$http
          .reqGetExtFunctionList(
            this.xufeiItem.productcode,
            this.xufeiItem.orderid
          )
          .then((res) => {
            // 获取扩展功能包
            if (res.rtncode === 1) {
              if (res.rltcode === 1) {
                this.gridItems = res.items.funcs;
                this.discountdescdetail = res.items.discountdescdetail; // 优惠信息
                this.vipItemBuyDay = res.items.days; // 天数
                this.gridItems.forEach((grid, index) => {
                  console.log("grid, index", grid, index);
                  if (
                    this.xufeiItem.productcode == "000001" &&
                    grid.funccode == "000009"
                  ) {
                    this.$set(this.gridItems[index], "alreadybought_1", 1); // 已购买的数量
                    this.$set(this.gridItems[index], "alreadybought_2", 0); // 输入框数量
                    this.$set(this.gridItems[index], "alreadybought_3", 0); // 输入框显示的数量
                  } else {
                    this.$set(
                      this.gridItems[index],
                      "alreadybought_1",
                      grid.alreadybought
                    ); // 已购买的数量
                    this.$set(
                      this.gridItems[index],
                      "alreadybought_2",
                      grid.maxactive - grid.alreadybought
                    ); // 最大购买数量
                    this.$set(this.gridItems[index], "alreadybought_3", 0); // 输入框显示的数量
                  }
                });
                this.getVipItemData(this.gridItems);
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    // 关闭弹框 初始化数据
    closePopup() {
      this.coupon = "";
      this.agentCode = "";
      this.radioPay = "1";
      this.sumMoney = 0;
      this.show = false;
      this.userAgreement = false;
      this.vipUpgradeAgreement = false;
      this.totalPrice = 0;
      this.totalMoney = 0;
      this.totalPriceYou = 0;
      this.totalMoneyYou = 0;
      this.loadingFlag = false;
      this.checked = false;
      this.result = [];
      this.vipItemBuyDay = 0;
    },
    // 改变数量
    inputChange() {
      let reqGridItems = [];
      this.gridItems.forEach((item) => {
        if (item.alreadybought_1 < item.maxactive && item.alreadybought_3 > 0) {
          reqGridItems.push(item);
        }
      });

      this.result = reqGridItems;
      this.getVipItemData(reqGridItems);
      this.caleCouponCodeAndAgentCode();
    },
    // vip计算优惠后得价格
    getVipItemData(gridItemsParams) {
      let extfunc = [];
      gridItemsParams.forEach((item) => {
        extfunc.push({
          func_code: item.funccode,
          func_name: item.funcname,
          number: item.alreadybought_3,
        });
      });
      this.checkFunOrderDiscount(extfunc);
    },
    // 验证扩展功能订单并计算优惠
    checkFunOrderDiscount(extfunc) {
      let params = {
        productcode: this.xufeiItem.productcode,
        productorderid: this.xufeiItem.orderid,
        paytype: 31,
        extfunc: extfunc,
      };
      this.$http
        .reqPostFunctionOrderAndCaleDiscount(params)
        .then((res) => {
          if (res.rtncode === 1) {
            if (res.rltcode === 1) {
              this.oldPrice = res.result.orderamount; // 原价
              this.totalMoney = res.result.actualamount;
              this.totalPrice = res.result.actualamount * 100; // 折后价
              this.totalMoneyYou = res.result.actualamount;
              this.totalPriceYou = res.result.actualamount * 100;
              this.vipItemBuyDay = res.result.days; // 剩余天数 购买天数
              this.discountdescdetail = res.result.discountdescdetail; // 优惠信息
              this.caleCouponCodeAndAgentCode();
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 获取发票弹框的内容
    getInvoiceParams(params, word) {
      console.log("获取发票的内容===", params, word);
      this.invoiceData = params;
      this.invoiceWord = word;
    },
    // 第一次获取已开发票的内容
    firstGetInvoiceParams() {
      this.$http
        .getInvoiceHeader()
        .then((res) => {
          if (res.rtncode === 1 && res.rltcode === 1 && res.item != null) {
            if (res.item.headertype === 1) {
              // 个人
              this.invoiceWord = "普通发票 个人";
              this.invoiceData.invoiceheader = res.item;
            } else if (res.item.headertype === 2) {
              // 公司
              this.invoiceWord = "普通发票 公司";
              this.invoiceData.invoiceheader = res.item;
            }
            this.$refs.invoice.inputMsg(res.item);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 发票
    drawABill() {
      this.$refs.invoice.openpopup();
      this.$refs.invoice.getTotalMoney(this.totalMoney);
    },
    // 点击管理文件仓库
    goToSmartcloud() {
      this.$router.push("smartcloud");
    },
    // 续费中提交订单
    onSubmit() {
      if (!this.checked) {
        this.alertDialog("您未确认使用优惠码，是否继续下单？");
      } else {
        if (!this.iconCouponFlag) {
          this.alertDialog(`${this.alertMessage}，是否继续下单？`);
        } else if (this.iconCouponFlag) {
          this.onConfirm();
        }
      }
    },
    // 提示信息弹框
    alertDialog(message) {
      this.$dialog
        .confirm({
          title: "提示",
          message: message,
          confirmButtonText: "下单",
        })
        .then(() => {
          // on confirm
          this.onConfirm();
        })
        .catch(() => {
          // on cancel
        });
    },
    onConfirm() {
      this.loadingFlag = true;
      if (this.radioPay === "1") {
        if (this.flag) {
          this.isWeixin();
        } else {
          let extfunc = [];
          this.result.forEach((item) => {
            extfunc.push({
              func_code: item.funccode,
              func_name: item.funcname,
              number: item.alreadybought_3,
            });
          });
          this.isWeixinItem(extfunc);
        }
      } else if (this.radioPay === "2") {
        console.log("支付宝支付");
      }
    },
    // 主套餐支付
    isWeixin() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        console.log("是微信浏览器", this.totalPrice / 100);
      } else {
        let params = {
          product: this.xufeiItem.productcode, // 购买的产品
          discount: this.yearDiscountcode, // 选择的优惠方式
          paytype: 31, // 支付方式，10 支付宝扫码，30 微信扫码，31 微信H5支付
          couponcode: this.iconCouponFlag ? this.coupon : "", // 优惠码或优惠卷代码
          agentcode: this.agentCode, // 运营商编码
          invoice: this.invoiceData, // 开票相关信息
        };
        this.$http
          .reqPostProductContinueOrder(params)
          .then((res) => {
            if (res.rtncode === 1) {
              if (res.rltcode === 1) {
                this.dataForm = res.result.strdata;
                console.log("主套餐支付this.dataForm", this.dataForm);
                this.getUserAgreement(res.result.orderid, "main");
              } else {
                commonToast(res.rltdesc, this);
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    // vip升级支付
    isWeixinItem(extfunc) {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        console.log("是微信浏览器", this.totalPrice / 100);
        let params = {
          productcode: this.xufeiItem.productcode,
          productorderid: this.xufeiItem.orderid,
          paytype: 32,
          extfunc: extfunc,
          couponcode: this.iconCouponFlag ? this.coupon : "", // 优惠码或优惠卷代码
          agentcode: this.agentCode, // 运营商编码
          invoice: this.invoiceData, // 开票相关信息
          wxopenid: sessionStorage.getItem("wxopenid"),
        };
        this.$http
          .reqPostFunctionOrder(params)
          .then((res) => {
            if (res.rtncode === 1) {
              if (res.rltcode === 1) {
                this.dataForm = JSON.parse(res.result.strdata);
                this.getUserAgreement(res.result.orderid, "vips");
              } else {
                commonToast(res.rltdesc, this);
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        let params = {
          productcode: this.xufeiItem.productcode,
          productorderid: this.xufeiItem.orderid,
          paytype: 31,
          extfunc: extfunc,
          couponcode: this.iconCouponFlag ? this.coupon : "", // 优惠码或优惠卷代码
          agentcode: this.agentCode, // 运营商编码
          invoice: this.invoiceData, // 开票相关信息
        };
        this.$http
          .reqPostFunctionOrder(params)
          .then((res) => {
            if (res.rtncode === 1) {
              if (res.rltcode === 1) {
                this.dataForm = res.result.strdata;
                this.getUserAgreement(res.result.orderid, "vips");
              } else {
                commonToast(res.rltdesc, this);
              }
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    // 获取用户协议的内容
    getUserAgreement(orderid, type) {
      this.$http
        .reqGetContractinfo(orderid)
        .then((res) => {
          if (res.rtncode === 1 && res.rltcode === 1) {
            this.userAgreementData = res.item;
            this.userAgreementData.detail.forEach((item) => {
              this.sumMoney += item.amount;
            });
            if (type == "main") {
              this.userAgreement = true;
              this.$nextTick(() => {
                let dom = document.getElementById("word_11");
                dom.scrollIntoView();
              });
            } else if (type == "vips") {
              this.vipUpgradeAgreement = true;
              this.$nextTick(() => {
                let dom = document.getElementById("word_22");
                dom.scrollIntoView();
              });
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 同意并确认支付
    agreePayMoney() {
      if (Number(localStorage.getItem("WX_VERSION")) === 1) {
        if (this.dataForm) {
          console.log("同意并确认支付是wx内", this.dataForm);
          wxpayFunc(this.dataForm, this.wxPayCallback);
        }
      } else {
        location.href = this.dataForm;
      }
    },
    // 微信内支付回调函数
    wxPayCallback(res) {
      console.log("微信内支付完成====>", res);
      if (res.err_msg == "get_brand_wcpay_request:ok") {
        // 使用以上方式判断前端返回,微信团队郑重提示：
        //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
        commonDialog("支付成功。", this, "确认", () => {
          this.loadingFlag = false;
          this.$http.refreshToken().then((res) => {
            this.bus.$emit("saveTokenHandle", res, 1);
            this.$router.push("/newFiles");
          });
        });
      } else {
        this.$notify({
          type: "warning",
          message: "用户支付失败!",
          duration: 5000,
        });
        this.loadingFlag = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/styles/variable.less";
#myPrivilege {
  background-color: #F6F6F6;
  min-height: 100%;
  .title {
    padding: 10px 0;
    background-color: #fff;
    border-top: 1px solid #ddd;
    display: flex;
    align-items: center;
  }
  .privilege {
    font-size: 0.37333rem;
    box-sizing: border-box;
    .open-time-wapper {
      background-color: #fff;
      border-radius: 0.26667rem;
      margin-bottom: 0.26667rem;
      padding: 0.26667rem;
      margin-top: 10px;
      .open-max-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .open-font {
          margin-right: 10px;
        }
      }
    }
    .orderList_1 {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #fff;
      border-radius: 10px;
      margin: 10px 0;
      padding: 10px;
      .flexBox {
        flex: 1;
        .listItem {
          display: flex;
          align-items: stretch;
          margin: 6px;
          .leftWord {
            flex: 0 0 82px;
          }
          .rightWord {
            flex: 1;
            display: flex;
            align-items: flex-end;
          }
        }
      }
      .continueBtnClass {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
      }
    }
    .orderList {
      background-color: #fff;
      margin: 10px 0;
      padding: 3px 3px 12px;
      box-sizing: border-box;
      border-radius: 10px;
      .listItem {
        display: flex;
        align-items: stretch;
        margin: 6px;
        .leftWord {
          flex: 0 0 82px;
        }
        .rightWord {
          flex: 1;
          display: flex;
          align-items: flex-end;
        }
      }
    }
  }
  .userAgreementContent {
    font-size: 14px;
    padding: 0 10px;
    margin-bottom: 3rem;
    & > h4 {
      margin-bottom: 0;
    }
    .contentItemP {
      & > p {
        text-indent: 20px;
        margin: 0;
        margin-top: 4px;
      }
      & > h5 {
        margin: 0;
        margin-top: 4px;
      }
    }
    .marginT {
      margin-top: 20px;
    }
    .zhangStyle {
      position: relative;
      & > img {
        position: absolute;
        top: 42%;
        left: 28%;
      }
    }
  }
.xufei-btn {
  color:#F93332;
  background-color: #FFF0F0;
  border-color: #fff;
  height: 27px;
  margin-left: 5px;
  border-radius: 3px;
}
/deep/.van-cell__title {
  color: #000;
  font-size: 15px;
  font-weight: 500;
}
/deep/.van-cell__value {
  color: #404040;
}
p {
  margin: 15px 0 5px 10px;
  color: #4D4D4D;
}
/deep/.van-icon-arrow-left {
  margin-left: 5px;
}
}
#xuFeiPage {
  background-color: #f7f7f7;
  padding-bottom: 2rem;
  .titleWord {
    padding: 10px 0 0;
  }
  .word_1 {
    color: #333;
    font-size: 14px;
    font-weight: bold;
  }
  .payMethodsxf {
    margin: 0 10px;
    .word {
      margin: 14px 0;
    }
    /deep/.van-cell__title {
      display: flex;
      align-items: center;
    }
    .custom-title {
      margin-left: 10px;
    }
    .vip-box {
      background-color: #fff;
      padding: 10px 10px;
      .vip-box-item {
        display: flex;
        align-items: center;
        padding: 10px 0;
        .vip-title {
          flex: 0 0 60px;
          margin: 0 10px 0 10px;
        }
        .num {
          flex: 1;
        }
        .price {
          flex: 0 0 100px;
          text-align: right;
        }
      }
    }
  }
  .line {
    width: 100%;
    height: 8px;
    background: #f6f6f6;
  }
  .van-tag {
    margin: 2px;
  }
  /deep/.van-cell--clickable:active {
    background-color: #fff;
  }
  /deep/.van-cell:not(:last-child)::after {
    -webkit-transform: scaleY(1);
    transform: scaleY(1);
    top: 0;
  }
}
</style>
